import styled from 'styled-components'

const MODAL_MAX_WIDTH = '650px'

export const ModalUserGuide = styled.section`
  max-width: ${MODAL_MAX_WIDTH};

  h3 {
    font-family: ${(props) => props.theme.typography.fontFamily};
    text-transform: none;
    font-size: 18px;
    margin-top: 30px;
    padding-top: 30px;
    border-top: 1px solid #4f504a;
  }
`
